<script>
import { handleResponseError } from '@/components/utils/globalFunction'
import RentalFileService from '@/services/rentalModule/RentalFileService'

export default {
  name: 'RentalFileAddPicturePage',
  data() {
    return {
      loading: false,
      sendStatus: false,
      tokenValidity: false,
      token: null,
      rentalFileId: null,

      fileList: []
    }
  },
  async created() {
    this.loading = true

    await this.$store.dispatch('auth/cleanSession')
    const urlParams = new URLSearchParams(window.location.search)
    this.token = urlParams.get('token')
    try {
      const response = await RentalFileService.validateRentalFileQrCodeToken(this.token)
      this.rentalFileId = response.rental_file_id
      this.tokenValidity = response.token_validity
    } catch (error) {
      handleResponseError(error)
    } finally {
      this.loading = false
    }
  },
  methods: {
    async sendFileList() {
      this.loading = true
      try {
        const formData = new FormData()
        let data = {
          qr_code_token: this.token,
          rental_file_id: this.rentalFileId
        }
        formData.append('data', JSON.stringify(data))

        this.fileList.forEach((file) => {
          formData.append('picture_list', file)
        })

        await RentalFileService.sendPictureWithQrCodeToken(formData)

        this.sendStatus = true
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<template>
  <v-app>
    <v-main class="main">
      <div v-if="tokenValidity && !sendStatus" class="container">
        <div class="mt-6 pa-4">
          <img src="@/assets/images/boomerang_black_logo.svg" alt="boomerang logo" class="mb-4" />
          <h2 class="font-weight-bold mb-5 d-flex justify-center">
            {{ $t('RENTAL_FILE_ADD_PICTURE.TITLE') }}
          </h2>
          <div class="mb-5">
            <p class="mb-5">{{ $t('RENTAL_FILE_ADD_PICTURE.MESSAGE') }}</p>
          </div>
          <p data-custom="true" class="mb-5">
            {{ $t('RENTAL_FILE_ADD_PICTURE.SELECT_TITLE') }}
          </p>
          <v-file-input
            class="logo-selector"
            required
            accept=".jpg, .png"
            multiple
            chips
            counter
            show-size
            v-model="fileList"
          >
            <template v-slot:append-inner>
              <img
                alt="download.svg"
                class="download-svg mr-4"
                src="@/assets/icons/file/download.svg"
              />
            </template>
          </v-file-input>

          <div class="d-flex justify-center">
            <v-btn
              class="boom-button dialog-button"
              :disabled="fileList.length === 0"
              :loading="loading"
              variant="outlined"
              @click="sendFileList"
            >
              {{ $t('COMMON.BUTTON.SEND') }}
            </v-btn>
          </div>
        </div>
      </div>

      <div v-if="tokenValidity && sendStatus" class="container">
        <div class="mt-6 pa-4">
          <img src="@/assets/images/boomerang_black_logo.svg" alt="boomerang logo" class="mb-4" />

          <h2 class="font-weight-bold mb-5 d-flex justify-center">
            {{ $t('RENTAL_FILE_ADD_PICTURE.TITLE_SENT') }}
          </h2>
          <div class="mb-5">
            <p class="mb-5">{{ $t('RENTAL_FILE_ADD_PICTURE.MESSAGE_SENT') }}</p>
          </div>
        </div>
      </div>

      <div v-if="!tokenValidity" class="container">
        <div class="mt-6 pa-4">
          <img src="@/assets/images/boomerang_black_logo.svg" alt="boomerang logo" class="mb-4" />

          <h2 class="font-weight-bold mb-5 d-flex justify-center">
            {{ $t('RENTAL_FILE_ADD_PICTURE.TITLE_ERROR_TOKEN_VALIDITY') }}
          </h2>
          <div class="mb-5">
            <p class="mb-5">{{ $t('RENTAL_FILE_ADD_PICTURE.MESSAGE_ERROR_TOKEN_VALIDITY') }}</p>
          </div>
        </div>
      </div>
    </v-main>
  </v-app>
</template>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
}

.download-svg {
  height: 20px;
  filter: invert(98%) sepia(0%) saturate(1853%) hue-rotate(181deg) brightness(96%) contrast(80%);
}
</style>
